require('./RAStrategyItem.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ commons
const OKTooltip = require('commonsComponents/OKTooltip');
// @ components
const FormattedTextWithComponents = require('components/FormattedTextWithComponents/FormattedTextWithComponents');
// @ utilities
import { formatText, FormattedText } from 'core/i18n';
// @ constants
const { INVEST_PROFILE, BUILDING_HEIGHTS } = require('constants/RAConstants');

class RAStrategyItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.ref = React.createRef();
    }

    handleClick() {
        const { disabled, id } = this.props;

        if (!disabled) {
            this.props.onSelectStrategy(id);
        }
    }

    buildTooltip(target) {
        const { disabled } = this.props;

        if (disabled) {
            return (
                <OKTooltip target={target} content={formatText('raStrategyItem-outOfBoundTooltip')} placement="top" />
            );
        }

        return target;
    }

    buildModifyTooltip(content, firstCardSelected) {
        const buildingCity = formatText(`raStrategyItem-raStrategyItem_${firstCardSelected}`);
        const contentFormatted = (
            <div>
                <FormattedTextWithComponents value={content} injectedComponents={[buildingCity]} />
            </div>
        );
        const tooltipContainer = <div className="ra-strategy-item__modify-tooltip-container" />;

        return <OKTooltip target={tooltipContainer} content={contentFormatted} fixed={true} />;
    }

    buildDetailsButton() {
        const { id, modifyPlan, selectedCard } = this.props;
        let showDetails = null;

        if (!modifyPlan && selectedCard === id) {
            showDetails = (
                <section className="ra-strategy-item__link-section hidden-xs">
                    <a
                        className="ra-strategy-item__link-details"
                        href="#"
                        onClick={event => {
                            event.preventDefault();
                            this.props.onStrategyDetailsClick();
                        }}
                    >
                        <FormattedText value="raStrategyItem-showDetails" />
                    </a>
                </section>
            );
        }

        return showDetails;
    }

    render() {
        const { disabled, id, selectedCard, firstCardSelected, modifyPlan, riskType } = this.props;
        const currentClassName = classNames('ra-strategy-item', {
            'ra-strategy-item--is-disabled': disabled,
        });
        const buildingClassName = classNames(`ra-strategy-item__building ra-strategy-item__building-${id}`, {
            [`ra-strategy-item__building-${id}--is-selected`]: selectedCard === id,
            [`ra-strategy-item__building-${id}--first-card`]: firstCardSelected === id,
        });
        const itemNameClassname = classNames(`ra-strategy-item__name ra-strategy-item__name-${id}`, {
            [`ra-strategy-item__name-${id}--is-selected`]: selectedCard === id,
            [`ra-strategy-item__name-${id}--first-card`]: firstCardSelected === id,
            [`ra-strategy-item__name-${id}--is-disabled`]: disabled,
        });
        const buildingHeightClassName = classNames(`ra-strategy-item__building-height`, {
            [`ra-strategy-item__building-height--is-selected`]: selectedCard === id,
        });

        const itemName = INVEST_PROFILE[id];
        const buildingHeight = BUILDING_HEIGHTS[id];
        const minContent = 'raStrategyItem-raStrategyItem_minTooltip';
        const maxContent = 'raStrategyItem-raStrategyItem_maxTooltip';
        const showDetails = this.buildDetailsButton();
        const maxTooltip =
            modifyPlan && selectedCard === id && firstCardSelected < id
                ? this.buildModifyTooltip(maxContent, firstCardSelected)
                : null;
        const minTooltip =
            modifyPlan && selectedCard === id && firstCardSelected > id
                ? this.buildModifyTooltip(minContent, firstCardSelected)
                : null;

        return this.buildTooltip(
            <div className={currentClassName} ref={this.ref}>
                {maxTooltip}
                {minTooltip}
                <div className="ra-strategy-item__container" onClick={this.handleClick}>
                    <div className={buildingClassName}></div>
                    <div className={buildingHeightClassName}>{buildingHeight}</div>
                    <div className="ra-strategy-item__type">{riskType}</div>
                    <div className={itemNameClassname}>{itemName}</div>
                </div>
                {showDetails}
            </div>
        );
    }
}

RAStrategyItem.propTypes = {
    disabled: PropTypes.bool,
    firstCardSelected: PropTypes.number,
    id: PropTypes.number.isRequired,
    modifyPlan: PropTypes.bool.isRequired,
    onSelectStrategy: PropTypes.func.isRequired,
    onStrategyDetailsClick: PropTypes.func,
    riskType: PropTypes.string.isRequired,
    selectedCard: PropTypes.number.isRequired,
};

RAStrategyItem.defaultProps = {
    disabled: false,
};

module.exports = RAStrategyItem;
